<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="content text-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                  <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!-- <div class="section-agency-benefit section-pt section-pb-60">
  <div class="container">
    <div class="content text-center">
      <div  class="col-lg-12">
        <div class="section-title text-center">
          <h3>Protectt.ai labs is helping the digital world to stay safe and secured. Our energy is channelized to
            achieve one common goal – Protectt. Our biggest trait is innovation, We believe that’s what made who we are
            today. We allow our team to experiment objectively and realize their truest potential. You will be part of
            this energetic and enthusiastic team when your expertise meets our expectation. Go ahead and apply for the
            appropriate job openings we have and become a part of the Protectt family</h3>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray section-pt section-pb">
  <div class="container">
    <div class="row align-items-center">
      <div  class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <span style="color: #da2b27;">Our clients</span>
            <div class="section-title title-2">
              <h2>The extended Protectt.ai Family</h2>
            </div>
            <p>Our clients are the best supporter of our success. We care for our clients and focus on providing the
              best solutions for their business operations.</p>
            <p> We, like to communicate transparently and keep no hidden terms. The transparency and our competence,
              reliability and good intentions forges trust.</p>
          </div>
        </div>
      </div>
      <div  class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/stock-1.webp" alt="Protectt.ai Family" class="og_image_url">
            <!-- <div class="play-btn">
                          <a class="video-popup" href="https://www.youtube.com/watch?v=G_G8SdXktHg"><i
                                  class="fa fa-play"></i></a>
                      </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit section-pt section-pb">
  <div class="container">
    <div class="row align-items-center">
      <div  class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <span style="color: #da2b27;">Innovativeness</span>
            <div class="section-title title-2">
              <h2>Breaking conventional tech boundaries</h2>
            </div>
            <p>We, believe in going miles to achieve the best-in class desired results. The continuous learning and
              trying new methodologies are the basic essence of organization.</p>
            <p>Trying, & failing doesn’t bound us. It excites to try and conquer the output to cyber secure mobile
              devices of our clients. </p>
            <p>“Learning curve must go on”</p>
          </div>
        </div>
      </div>
      <div  class="col-lg-6 order-md-first">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/stock-2.webp" alt="Innovativeness">
            <!-- <div class="play-btn">
                          <a class="video-popup" href="https://www.youtube.com/watch?v=G_G8SdXktHg"><i
                                  class="fa fa-play"></i></a>
                      </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray section-pt section-pb">
  <div class="container">
    <div class="row align-items-center">
      <div  class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <span style="color: #da2b27;">Ethics and Purpose</span>
            <div class="section-title title-2">
              <h2>Commitment to excellence</h2>
            </div>
            <p>We are free will organization with no time or space boundaries to adventure. But, all this comes with the
              strong ethics and accountability to serve the main purpose – deliver best-in class quality to our
              customers.</p>
          </div>
        </div>
      </div>
      <div  class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/stock-3.webp" alt="Ethics and Purpose">
            <!-- <div class="play-btn">
                          <a class="video-popup" href="https://www.youtube.com/watch?v=G_G8SdXktHg"><i
                                  class="fa fa-play"></i></a>
                      </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Party Images -->
<div class="section-agency-benefit section-pt section-pb-60">
  <div class="container">
    <div class="row align-items-center">
      <div  class="col-lg-4">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/festival-1.webp" alt="New Year Celebration">
            <pre></pre>
            <h5>New Year Celebration</h5>
          </div>
        </div>
      </div>
      <div  class="col-lg-4">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/festival-2.webp" alt="Christmas Celebration">
            <pre></pre>
            <h5>Christmas Celebration</h5>
          </div>
        </div>
      </div>
      <div  class="col-lg-4">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/festival-3.webp" alt="Birthday Celebration">
            <pre></pre>
            <h5>Birthday Celebration</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- End Party Images -->

<!-- Start Services Images -->
<div class="section-agency-benefit section-pt section-pb-60">
  <div class="container">
    <div class="content text-center">
      <div class="col-lg-12">
        <div  class="section-title text-center">
          <h2>Join our Family </h2>
          <pre></pre>
          <pre></pre>
          <h3>Be a #Protecttor</h3>
        </div>
      </div>
    </div>
    <div class="row align-items-center">
      <div  class="col-lg-4">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/product-engineering.webp" alt="Product Engineering">
            <pre></pre>
            <h5>Product Engineering </h5>
            <pre></pre>
            <!-- <a class="btn-circle btn-transparent btn" href="#">Schedule a free Demo today</a> -->
          </div>
        </div>
      </div>
      <div  class="col-lg-4">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/cyber-lab-services.webp" alt="Cyber Lab Services">
            <pre></pre>
            <h5>Cyber Lab Services</h5>
            <pre></pre>
            <!-- <a class="btn-circle btn-transparent btn" href="#">Schedule a free Demo today</a> -->
          </div>
        </div>
      </div>
      <div  class="col-lg-4">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/life-at-protectt-ai/corporate-affairs.webp" alt="Corporate Affairs">
            <pre></pre>
            <h5>Corporate Affairs</h5>
            <pre></pre>
            <!-- <a class="btn-circle btn-transparent btn" href="#">Schedule a free Demo today</a> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="content text-center">
      <a class="btn-circle btn-transparent btn" routerLink="/careers">Schedule a free Demo today</a>
    </div> -->
  </div>
</div>

<!-- End Services Images -->
